import { useState } from 'react'
import type { AppExtensionUi } from './types'

/**
 * The one hook the shells own for app-extension UI state — called exactly once, unconditionally,
 * no matter how many extensions get registered. Extensions themselves are plain functions that
 * read/write this state instead of holding their own useState.
 */
export const useAppExtensionState = (): AppExtensionUi => {
  const [dialog, setDialog] = useState<string | null>(null)
  const [payload, setPayload] = useState<Record<string, unknown>>({})

  const openDialog = (nextDialog: string, nextPayload: Record<string, unknown> = {}) => {
    setDialog(nextDialog)
    setPayload(nextPayload)
  }

  const closeDialog = () => {
    setDialog(null)
    setPayload({})
  }

  const patchPayload = (patch: Record<string, unknown>) => setPayload(prev => ({ ...prev, ...patch }))

  return { dialog, payload, openDialog, closeDialog, patchPayload }
}
